// Selskaps-velger: rendrer konsern-nodene som pills (ikke hardkodede knapper).
// Kontrollert komponent — klikk på en pill kaller `onVelg(orgNumber)`, og
// forelder-siden oppdaterer aktivt org.nr (som igjen driver Brreg-/eksponerings-
// /pengestrøm-spørringene). Den aktive noden får .pill.on-glød.
import type { KonsernNode } from "../api/konsern";

const RELASJON_TEKST: Record<KonsernNode["relasjon"], string> = {
  aktiv: "",
  mor: "mor",
  datter: "datter",
};

interface SelskapsVelgerProps {
  noder: KonsernNode[];
  aktivOrg: string;
  onVelg: (orgNumber: string) => void;
}

export function SelskapsVelger({ noder, aktivOrg, onVelg }: SelskapsVelgerProps) {
  return (
    <>
      {noder.map((node) => {
        const aktiv = node.orgNumber === aktivOrg;
        const label = RELASJON_TEKST[node.relasjon];
        return (
          <button
            key={node.orgNumber}
            type="button"
            className={`pill${aktiv ? " on" : ""}`}
            aria-pressed={aktiv}
            onClick={() => onVelg(node.orgNumber)}
          >
            {node.name ?? node.orgNumber}
            {label && <span className="ml-[7px] text-[11px] font-normal opacity-70">{label}</span>}
          </button>
        );
      })}
    </>
  );
}
